import angular from 'angular';

import Component from './weekday-editor.component';

const Module = angular
    .module('control-room.commons.basic.components.weekday-editor', [])
    .component('crWeekdayEditor', Component);

export default Module;
